import { HttpErrorResponse } from '@angular/common/http';

/** Auth flow debug logs — filter DevTools console with `[auth]`. */
export function logAuthError(
  context: string,
  error?: unknown,
  extra?: Record<string, unknown>
): void {
  const payload: Record<string, unknown> = { context, ...extra };

  if (error instanceof HttpErrorResponse) {
    payload.status = error.status;
    payload.statusText = error.statusText;
    payload.url = error.url;
    payload.body = error.error;
  } else if (error !== undefined) {
    payload.error = error;
  }

  console.error('[auth]', payload);
}

export function logAuthWarn(
  context: string,
  extra?: Record<string, unknown>
): void {
  console.warn('[auth]', { context, ...extra });
}
